/*
 * @Descripttion: 菜单树
 * @Author: chenjinsheng
 * @Date: 2021-10-26 11:46:42
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-03 10:30:14
 */
const iframeUrl = new Map([
    [
        "MBHZGL",
        "https://d-board.newhope.cn:9091/webroot/decision/url/goAuth?callBack=https%3A%2F%2Fd-board.newhope.cn%3A9091%2Fwebroot%2Fdecision%2Fview%2Fform%3Fviewlet%3Dnewhope_fdc%2Freportsmanage%2Fvalue_manage%2Fvalue_target_value_form.cpt%26op%3Dwrite",
    ],
    [
        "GHJHGL",
        "https://d-board.newhope.cn:9091/webroot/decision/url/goAuth?callBack=https%3A%2F%2Fd-board.newhope.cn%3A9091%2Fwebroot%2Fdecision%2Fview%2Fform%3Fviewlet%3Dnewhope_fdc%2Freportsmanage%2Fvalue_manage%2Fvalue_supply_plan_form.cpt%26op%3Dwrite",
    ],
    [
        "GHDCGL",
        "https://d-board.newhope.cn:9091/webroot/decision/url/goAuth?callBack=https%3A%2F%2Fd-board.newhope.cn%3A9091%2Fwebroot%2Fdecision%2Fview%2Fform%3Fviewlet%3Dnewhope_fdc%2Freportsmanage%2Fvalue_manage%2Fvalue_supply_plan_form_city.cpt%26op%3Dwrite",
    ],
    [
        "LDJHGL",
        "https://d-board.newhope.cn:9091/webroot/decision/url/goAuth?callBack=https%3A%2F%2Fd-board.newhope.cn%3A9091%2Fwebroot%2Fdecision%2Fview%2Fform%3Fviewlet%3Dnewhope_fdc%2Freportsmanage%2Fvalue_manage%2Fvalue_building_plan_form.cpt%26op%3Dwrite",
    ],
    [
        "LDJHDCGL",
        "https://d-board.newhope.cn:9091/webroot/decision/url/goAuth?callBack=https%3A%2F%2Fd-board.newhope.cn%3A9091%2Fwebroot%2Fdecision%2Fview%2Fform%3Fviewlet%3Dnewhope_fdc%2Freportsmanage%2Fvalue_manage%2Fvalue_building_actual_form.cpt%26op%3Dwrite",
    ],
    [
        "DTHZGL",
        "https://d-board.newhope.cn:9091/webroot/decision/url/goAuth?callBack=https%3A%2F%2Fd-board.newhope.cn%3A9091%2Fwebroot%2Fdecision%2Fview%2Fform%3Fviewlet%3Dnewhope_fdc%2Freportsmanage%2Fvalue_manage%2Fvalue_dynamic_form.cpt%26op%3Dwrite",
    ],
    [
        "LDZYFX",
        "https://d-board.newhope.cn:9091/webroot/decision/url/goAuth?callBack=https%3A%2F%2Fd-board.newhope.cn%3A9091%2Fwebroot%2Fdecision%2Fview%2Fform%3Fviewlet%3Dnewhope_fdc%2Freportsmanage%2Ffloor_info%2Ffloo_info_view_new.cpt",
    ],
    [
        "MBHZTBSP",
        "https://d-board.newhope.cn:9091/webroot/decision/url/goAuth?callBack=https%3A%2F%2Fd-board.newhope.cn%3A9091%2Fwebroot%2Fdecision%2Fview%2Fform%3Fviewlet%3Dnewhope_fdc%2Freportsmanage%2Fvalue_manage%2Fvalue_target_value_valid_form.cpt%26op%3Dwrite",
    ],
    [
        "LDJHTBSP",
        "https://d-board.newhope.cn:9091/webroot/decision/url/goAuth?callBack=https%3A%2F%2Fd-board.newhope.cn%3A9091%2Fwebroot%2Fdecision%2Fview%2Fform%3Fviewlet%3Dnewhope_fdc%2Freportsmanage%2Fvalue_manage%2Fvalue_building_plan_valid_form.cpt%26op%3Dwrite",
    ],
    ["YTZYFX", ""],
    ["GXCFX", ""],
    ["SKXMJK", ""],
]);

export const menuTree = [
    {
        label: "资源管理",
        moduleCode: "ZYGL",
        children: [
            {
                label: "01目标货值管理",
                moduleCode: "MBHZGL",
                url: iframeUrl.get("MBHZGL"),
                children: [],
            },
            {
                label: "02供货计划管理",
                moduleCode: "GHJHGL",
                url: iframeUrl.get("GHJHGL"),
                children: [],
            },
            {
                label: "03供货达成管理",
                moduleCode: "GHDCGL",
                url: iframeUrl.get("GHDCGL"),
                children: [],
            },
            {
                label: "04楼栋计划管理",
                moduleCode: "LDJHGL",
                url: iframeUrl.get("LDJHGL"),
                children: [],
            },
            {
                label: "05计划达成管理",
                moduleCode: "LDJHDCGL",
                url: iframeUrl.get("LDJHDCGL"),
                children: [],
            },
            {
                label: "06动态货值管理",
                moduleCode: "DTHZGL",
                url: iframeUrl.get("DTHZGL"),
                children: [],
            },
            {
                label: "目标货值填报审批",
                moduleCode: "MBHZTBSP",
                url: iframeUrl.get("MBHZTBSP"),
                children: [],
            },
            {
                label: "楼栋计划填报审批",
                moduleCode: "LDJHTBSP",
                url: iframeUrl.get("LDJHTBSP"),
                children: [],
            },
        ],
    },
    {
        label: "报表中心",
        moduleCode: "BBZX",
        children: [
            {
                label: "资源管理分析",
                moduleCode: "ZYGLFX",
                children: [
                    {
                        label: "楼栋资源分析",
                        moduleCode: "LDZYFX",
                        url: iframeUrl.get("LDZYFX"),
                        children: [],
                    },
                    // {
                    //     label: "业态资源分析",
                    //     moduleCode: "YTZYFX",
                    //     url: iframeUrl.get("YTZYFX"),
                    //     children: [],
                    // },
                    // {
                    //     label: "供销存分析",
                    //     moduleCode: "GXCFX",
                    //     url: iframeUrl.get("GXCFX"),
                    //     children: [],
                    // },
                    // {
                    //     label: "首开项目监控",
                    //     moduleCode: "SKXMJK",
                    //     url: iframeUrl.get("SKXMJK"),
                    //     children: [],
                    // },
                ],
            },
        ],
    },
];
